import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, API } from "../lib/api";

const SiteImagesContext = createContext(null);

export function SiteImagesProvider({ children }) {
  const [uploaded, setUploaded] = useState([]);
  const [version, setVersion] = useState(0);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/image-slots");
      setUploaded(data.uploaded || []);
      setVersion((v) => v + 1);
    } catch {
      /* ignore */
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  // Returns the uploaded image URL for a slot key, or the provided fallback.
  const resolve = useCallback(
    (key, fallback) =>
      uploaded.includes(key) ? `${API}/images/${key}?v=${version}` : fallback,
    [uploaded, version]
  );

  return (
    <SiteImagesContext.Provider value={{ uploaded, resolve, refresh }}>
      {children}
    </SiteImagesContext.Provider>
  );
}

export const useSiteImages = () => useContext(SiteImagesContext);
